import { SystemOverview } from "@/components/admin/SystemOverview";

export default function SystemOverviewPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">System Overview</h2>
        <p className="text-muted-foreground">Monitor system statistics and health</p>
      </div>
      <SystemOverview />
    </div>
  );
}
